module.exports = __webpack_public_path__ + "img/annuity_start_age_white.2eb72c9.svg";